'use client';

import Image, { type ImageProps } from '@/components/shared/Image';
import { resolveMediaUrl } from '@/lib/media';

function needsUnoptimized(src: ImageProps['src']): boolean {
  if (typeof src !== 'string') return false;
  return (
    src.startsWith('/upload/') ||
    src.includes('/storage/v1/object/public/') ||
    /\.(avif|heic|heif)$/i.test(src)
  );
}

/** Image wrapper for CMS uploads — resolves /upload/* to Supabase Storage URL */
export function UploadedImage({ src, ...props }: ImageProps) {
  const resolved =
    typeof src === 'string' ? resolveMediaUrl(src) : src;
  return <Image src={resolved} unoptimized={needsUnoptimized(src)} {...props} />;
}
